import { useState } from "react";

import {
  Paper,
  TableContainer,
  Box
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

export default function BillToTable(props) {
  const {
    rows,
    setSelectedRow,
    isLoading,
    handleQueryPageChange,
    rowsCount,
    handleSortChangeData,
    setEditShipperClicked,
    isOrderScreen,
  } = props;

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 50,
    page: 1,
  });
  const [sortData, setSortData] = useState({
    field: "name",
    sort: "asc",
  });
  const [selectedRowId, setSelectedRowId] = useState("");

  const tableColumns = [
    {
      field: "code",
      headerName: "Bill To #",
      headerClassName: "MuiDataGrid-columnHeaders",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "name",
      headerName: "Bill To",
      headerClassName: "MuiDataGrid-columnHeaders",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "city",
      headerName: "City",
      headerClassName: "MuiDataGrid-columnHeaders",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "state",
      headerName: "State",
      headerClassName: "MuiDataGrid-columnHeaders",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "MuiDataGrid-columnHeaders",
      flex: 1,
      minWidth: 100,
    },
  ];


  const handleRowClick = (params) => {
    setSelectedRowId(params?.id);
    setSelectedRow(params?.row?.code);
    setEditShipperClicked(true);
  };

  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page });
    handleQueryPageChange(params, sortData);
  };
  const handleSortChange = (sortModel) => {
    const sortDataToServer = {
      field: "name",
      sort: "asc",
    };
    if (sortModel[0]) {
      const { field, sort } = sortModel[0];
      sortDataToServer.field = field;
      sortDataToServer.sort = sort;
    }

    setSortData(sortDataToServer);
    handleSortChangeData(paginationModel, sortDataToServer);
  };
  return (
    <TableContainer component={Paper} style={{ width: "100%", height: "100%" }}>
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          height: "100%",
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
          "& .tableTH": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-columnHeaders": {
            // backgroundColor: "rgba(9, 29, 163, 1)",
            backgroundColor: "rgb(11, 67, 135)",
            color: "rgba(255, 255, 255, 1)",
            fontSize: "12px",
          },
          "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "rgba(255, 255, 255, 1)",
          },
          "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "rgba(255, 255, 255, 1)",
          },
          "& .super-app-theme--cell": {
            backgroundColor: "white",
            fontSize: "11px",
          },
          "& .selected-row": {
            backgroundColor: "#D3D3D3 !important", // Highlight selected row
          },
        }}
      >
        <DataGridPro
          rows={rows}
          rowCount={rowsCount}
          columns={tableColumns}
          getRowClassName={(params) =>
            selectedRowId === params?.id ? "selected-row" : ""
          }
          editMode="row"
          columnHeaderHeight={30}
          rowHeight={30}
          // checkboxSelection
          disableRowSelectionOnClick
          // hideFooter={true}
          // hideFooterRowCount={true}
          // onRowClick={handleRowClick}
          onRowClick={isOrderScreen ? null : handleRowClick}
          onRowDoubleClick={isOrderScreen ? handleRowClick : null}
          loading={isLoading}
          paginationMode="server"
          pagination={true}
          paginationModel={paginationModel}
          pageSizeOptions={[10, 25, 50]}
          onPaginationModelChange={(params) => {
            handlePageChange(params);
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: paginationModel.pageSize,
                page: paginationModel.page,
              },
            },
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
          onSortModelChange={handleSortChange}
          // onRowSelectionModelChange={handleSelectionChange}
        />
      </Box>
    </TableContainer>
  );
}
